<div class="identity-visualizer-tab">
    <div class="visualizer-fullscreen-button icon-expand" title="Open in window" (click)="openFullScreen()"></div>
    <ng-container #visualizerHost></ng-container>
</div>
